<ng-container *ngIf="isBrowser && !disableLazyLoad; else normalImage">
  <ion-img
    #imageWrapper
    [style.opacity]="imgUrl ? '1' : '0'"
    [src]="imgUrl"
    [alt]="alt || ''"
    [class.hasBackground]="showBackground"></ion-img>
</ng-container>
<ng-template #normalImage>
  <img
  [src]="imgUrl || src"
  [style.opacity]="imgUrl || src ? '1' : '0'"
  [alt]="alt || ''"
  class="ion-img"
  fetchpriority="high"
  #imageWrapper />
</ng-template>
